import { Course } from "@/db/coursesData";
import Image from "next/image";
import Link from "next/link";

const CoursesCard = ({ course }: { course: Course }) => {
  return (
    <div className="single-course-box mb-25 position-relative">
      <h3 className="fw-semibold fs-5">
        <Link href={`/enquiryPage?title=${encodeURIComponent(course.title)}`}>
          {course.title}
        </Link>
      </h3>
      <p className="fs-6">{course.description}</p>
      <div className="instructor d-flex align-items-center">
        <Image
          width={50}
          height={50}
          sizes="100vw"
          src={course.instructor.image}
          className="rounded-circle"
          alt="user-image"
        />
        <div>
          <h4 className="fw-medium fs-6">{course.instructor.name}</h4>
          <span className="d-block fs-6">{course.instructor.role}</span>
        </div>
      </div>
      <Link
        href={`/enquiryPage?title=${encodeURIComponent(course.title)}`}
        className="default-btn"
      >
        More
      </Link>
    </div>
  );
};

export default CoursesCard;
